import React, { useState } from "react";
import { RoundShape } from "../Assets";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TailSpin } from "react-loader-spinner";

const Footer = () => {
  const [loader, setLoader] = useState(false);
  const d = new Date();
  const date = d.getFullYear();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    msg: "",
  });

  const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      " ",
    ];
    const isValidChar = /^[A-Za-z\s]$/.test(e.key);

    if (!isValidChar && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }

    if (e.target.value.length >= 50 && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSend = async () => {
    try {
      if (!formData.name || !formData.email || !formData.msg) {
        toast.error("All fields are required!", {
          position: "top-center",
          autoClose: 3500,
        });
        return;
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.email)) {
        toast.error("Please enter a valid email address!", {
          position: "top-center",
          autoClose: 3500,
        });
        return;
      }

      setLoader(true);

      const formDataToSend = {
        FullName: formData.name,
        EmailAddress: formData.email,
        Message: formData.msg,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_SEND_EMAIL}`,
        formDataToSend,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (res) {
        setLoader(false);
        toast.success("Message sent successfully!", {
          position: "top-center",
          autoClose: 3500,
        });
      }
    } catch (error) {
      setLoader(false);
      console.error("error :", error);
      toast.error("Unable to send message", {
        position: "top-center",
        autoClose: 3500,
      });
    }
    setFormData({ name: "", email: "", msg: "" });
  };

  return (
    <footer className="footer-area bg-f7fafd">
      <div id="contact-list">
        <div
          className="row justify-content-center"
          style={{ rowGap: "30px", margin: "0" }}
        >
          {loader && (
            <div className="tailspinDiv">
              <TailSpin
                className="tailspin"
                color="white"
                height={80}
                width={80}
              />
            </div>
          )}

          <div
            className="col-md-5 col-xxl-2 col-9 aos-init aos-animate"
            data-aos="fade-in"
            data-aos-delay="300"
            data-aos-duration="1200"
            data-aos-once="false"
          >
            <div className="contact-cont">
              <h3>Contact</h3>
              <label htmlFor="name">Your Name:</label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
              />
              <label htmlFor="email">Your Email:</label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
              />
              <label htmlFor="msg">Your Message:</label>
              <textarea id="msg" value={formData.msg} onChange={handleChange} />

              <div className="pt-3">
                <button
                  style={{
                    backgroundColor: "#28a745",
                    boxShadow: "0 10px 20px 0 rgba(198, 121, 227, .25)",
                    border: "none",
                    color: "#FFF",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontWeight: 600,
                    padding: "5px 20px",
                  }}
                  onClick={handleSend}
                >
                  Send
                </button>
                <button
                  style={{
                    backgroundColor: "#c679e3",
                    boxShadow: "0 13px 27px 0 rgba(198, 121, 227, .25)",
                    border: "none",
                    color: "#FFF",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontWeight: 600,
                    padding: "5px 20px",
                    marginLeft: "5px",
                  }}
                  onClick={() => setFormData({ name: "", email: "", msg: "" })}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
          <div
            className=" col-12 col-lg-11 col-xxl-7 aos-init aos-animate"
            data-aos="fade-in"
            data-aos-delay="400"
            data-aos-duration="1200"
            data-aos-once="false"
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundImage:
                "url(	https://spet-gatsby.envytheme.com/static/map-3f6e1ddb342185a26c476daa59c3a805.png)",
              backgroundRepeat: "no-repeat",
            }}
          >
            <h3
            // style={{
            //   fontSize: "18px",
            //   color: "#000",
            //   fontWeight: "bold",
            //   marginBottom: "10px",
            // }}
            >
              Address
            </h3>
            <div className="d-flex flex-wrap justify-content-start  justify-content-lg-around mt-3">
              <div className="single-footer-widget">
                <ul className="footer-contact-info text-start ">
                  <li style={{ fontWeight: "bold", color: "black" }}>
                    USA Office
                  </li>
                  <li>
                    1309 Coffeen Avenue STE 3887 <br />
                    Sheridan, WY 82801
                  </li>
                  <li>
                    Email:{" "}
                    <a href="mailto:marketing@sankarasoftware.com">
                      marketing@sankarasoftware.com
                    </a>
                  </li>
                  <li>
                    Phone: <a href="tel:8058008599">+ (805) 800-8599</a>
                  </li>
                </ul>
              </div>
              <div className="single-footer-widget">
                <ul className="footer-contact-info text-start">
                  <li style={{ fontWeight: "bold", color: "black" }}>
                    Canada Office
                  </li>
                  <li>
                    1961 Cedarpark Dr London, <br />
                    Ontario, N5X 0J1
                  </li>
                  <li>
                    Email:{" "}
                    <a href="mailto:marketing@sankarasoftware.com">
                      marketing@sankarasoftware.com
                    </a>
                  </li>
                  <li>
                    Phone: <a href="tel:8058008599">+ (805) 800-8599</a>
                  </li>
                </ul>
              </div>
              <div className="single-footer-widget">
                <ul className="footer-contact-info text-start">
                  <li style={{ fontWeight: "bold", color: "black" }}>
                    India Office
                  </li>
                  <li>
                    1st Floor, 12A Tansi Nagar <br />
                    Velacherry, Chennai 600042
                  </li>
                  <li>
                    Email: <br />
                    <a href="mailto:info@sankarasoftware.com">
                      info@sankarasoftware.com
                    </a>
                    <br />
                    <a href="mailto:enquiry@sankarasoftware.com">
                      enquiry@sankarasoftware.com
                    </a>
                  </li>
                  <li>
                    Phone: <a href="tel:7358106170">+91 73581 06170 </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className=" col-10">
            <div className="copyright-area">
              <p>
                Copyright © {date} by Sankara Software. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="shape1">
        <img src={RoundShape} alt="shapertrt" />
      </div>
      <div className="shape2 rotateme">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
          alt="shape"
        />
      </div>
      <div className="shape3">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOC41NjIiIGhlaWdodD0iMjguNTk0IiB2aWV3Qm94PSIwIDAgMjguNTYyIDI4LjU5NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogbm9uZTsKICAgICAgICBzdHJva2U6ICNlMWUxZTE7CiAgICAgICAgc3Ryb2tlLXdpZHRoOiAzcHg7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMTQuMjgxIiBjeT0iMTQuMjk3IiByPSIxMi43ODEiLz4KPC9zdmc+Cg=="
          alt="shape"
        />
      </div>
      <div className="shape4">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
          alt="shape"
        />
      </div>
      <div className="shape7">
        <img
          src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjEgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUzICg3MjUyMCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aCA1PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIxMDAlIiB4Mj0iNTAlIiB5Mj0iLTQ5Ljg5MTAwNzIlIiBpZD0ibGluZWFyR3JhZGllbnQtMSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiMwMEU5MkIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0NDRkZBOCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYWluLUZpbGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIwLjY1ODU5Mzc1Ij4KICAgICAgICA8ZyBpZD0iMDFfaW5kZXgtQWdlbmN5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMzLjAwMDAwMCwgLTU2Mi4wMDAwMDApIiBzdHJva2U9InVybCgjbGluZWFyR3JhZGllbnQtMSkiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJCYW5uZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNy4wMDAwMDAsIDM1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9IlNoYXBlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgMjAzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyLjUwMDAwMCwgMzI5LjUwMDAwMCkgcm90YXRlKC0yMjguMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjUwMDAwMCwgLTMyOS41MDAwMDApICIgcG9pbnRzPSIyIDMyMyAxMi41OTgzNjA3IDMzNiAyMyAzMjMiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
          alt="shape"
        />
      </div>
      <div className="shape8 rotateme">
        <img
          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmb250LXNpemU6IDI1cHg7CiAgICAgICAgZmlsbDogIzI3ZWFjODsKICAgICAgICB0ZXh0LWFuY2hvcjogbWlkZGxlOwogICAgICAgIGZvbnQtZmFtaWx5OiBSb2JvdG87CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDx0ZXh0IGlkPSJfIiBkYXRhLW5hbWU9IisiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJtYXRyaXgoMS40MzcsIDEuNDM0LCAtMS40MzcsIDEuNDM0LCAtMC44MzIsIDIzLjA2NikiPjx0c3BhbiB4PSIwIj4rPC90c3Bhbj48L3RleHQ+Cjwvc3ZnPgo="
          alt="shape"
        />
      </div>
    </footer>
  );
};

export default Footer;
